import type {
	RovoApp,
	SourceMode,
} from '@atlassian/conversation-assistant-chat-prompt-input/controllers/chat-mode-store/types';
import { useChatModeStoreActions as useChatModeStoreActionsRefresh } from '@atlassian/conversation-assistant-chat-prompt-input/useChatModeStoreActions';
import type { AutoActionApprovalMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const useOnNewConversationStartedWithSendMessage = () => {
	const { setChatMode } = useChatModeStoreActionsRefresh();

	return (
		newConversationId: string,
		mode: {
			autoActionApprovalMode?: AutoActionApprovalMode;
			deepResearchEnabled?: boolean;
			thinkDeeperEnabled?: boolean;
			alphaExtendedThinkingMode?: 'MARATHON' | 'LONG_HORIZON';
			fastModeEnabled?: boolean;
			planModeEnabled?: boolean;
			webSearchEnabled?: boolean;
			sourceMode?: SourceMode;
			useCurrentPageContext?: boolean;
			spaceSourceCount?: number;
			appFilters?: RovoApp[];
			selectedCloudIds?: string[];
		},
	): void => {
		setChatMode(newConversationId, {
			autoActionApprovalMode: mode.autoActionApprovalMode ?? 'ALWAYS_HUMAN',
			// TODO: ROVOFE-1411 - refactor into passing the reasoningMode directly
			reasoningMode: mode.deepResearchEnabled
				? 'deep-research'
				: mode.thinkDeeperEnabled
					? mode.alphaExtendedThinkingMode === 'LONG_HORIZON'
						? 'think-deeper-orchestrator'
						: mode.alphaExtendedThinkingMode === 'MARATHON'
							? 'think-deeper-marathon'
							: 'think-deeper'
					: mode.planModeEnabled
						? 'task'
						: mode.fastModeEnabled
							? 'fast'
							: 'auto',
			webSearchEnabled: mode.webSearchEnabled ?? false,
			sourceMode: mode.sourceMode ?? 'GENERAL',
			useCurrentPageContext: mode.useCurrentPageContext ?? false,
			spaceSourceCount: mode.spaceSourceCount,
			appFilters: mode.appFilters,
			selectedCloudIds: mode.selectedCloudIds ?? [],
		});
	};
};
